import type { Route } from '~/core/router'

import { features, options } from '~/core/flags'
import { profilesFeaturesModel } from '~/features/profiles'
import * as accountSettings from '~/routes/settings/account-settings'
import * as contentSettings from '~/routes/settings/content-settings'
import * as dataSources from '~/routes/settings/data-sources'
import * as info from '~/routes/settings/info'
import * as root from '~/routes/settings/root'
import * as videoAudio from '~/routes/settings/video-audio'
import { aye } from '~/shared/helpers'

export const route: Route = {
  filter: {
    source: profilesFeaturesModel.$isActiveProfileRegular,
    fn: (isActiveProfileRegular) => aye(isActiveProfileRegular),
  },
  children: [
    {
      path: '',
      component: [root.Title, root.SettingsPage],
      init: root.model.init,
    },
    {
      path: '/info',
      component: [info.Title, info.SettingsInfoPage],
      init: info.model.init,
    },
    {
      path: '/content-settings',
      component: [
        contentSettings.Title,
        contentSettings.ContentSettingsSubPage,
      ],
      init: contentSettings.model.init,
    },
    {
      path: '/video-audio',
      component: [videoAudio.Title, videoAudio.SettingsVideoAudioPage],
      init: videoAudio.model.init,
    },
    {
      path: '/data-sources',
      component: [dataSources.Title, dataSources.DataSourcesSubPage],
      init: dataSources.model.init,
      filter: {
        source: options.$movieNightEnabled,
        fn: (movieNightEnabled) => aye(movieNightEnabled),
      },
    },
    {
      path: '/account-settings',
      component: [
        accountSettings.Title,
        accountSettings.AccountSettingsSubPage,
      ],
      init: accountSettings.model.init,
      left: accountSettings.model.left,
      filter: {
        source: features.$featuredFlags,
        fn: (flags) => aye(flags.inAppCredentialsChangeEnabled),
      },
    },
  ],
}
